/**
 * Card Create Component
 * Form for creating new profile cards
 */

import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  ReferenceInput,
  required,
} from 'react-admin';
import { Typography, Box } from '@mui/material';
import { CARD_TYPE_CHOICES } from '../constants';
import { CardScoringInputs } from './CardScoringInputs';

export function CardCreate() {
  return (
    <Create title="Create Card">
      <SimpleForm>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
          <Typography variant="h6" gutterBottom>New Card</Typography>
          <CardScoringInputs />

          <TextInput
            source="statement"
            label="Statement"
            multiline
            rows={3}
            validate={required()}
            fullWidth
          />

          <Box sx={{ display: 'flex', gap: 2 }}>
            <SelectInput
              source="type"
              label="Type"
              choices={CARD_TYPE_CHOICES}
              validate={required()}
              defaultValue="Direct"
              sx={{ minWidth: 200 }}
            />

            <ReferenceInput
              source="categoryId"
              reference="content/categories"
              label="Category"
            >
              <SelectInput
                optionText="name"
                optionValue="id"
                validate={required()}
                sx={{ minWidth: 200 }}
              />
            </ReferenceInput>
          </Box>

          <TextInput
            source="subdomainId"
            label="Subdomain ID"
            validate={required()}
          />
        </Box>
      </SimpleForm>
    </Create>
  );
}
